import model from './model';

const actions = {
  assignDocumentFile: model.assign<'SUBMIT_DOCUMENT_FILE'>({
    documentFile: (context, event) => event.data,
  }),
};

export default actions;
